import { Fragment, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../forms/CheckoutForm";
import FilingResume from "./resumes/FilingResume";

const stripe_pk_from_env = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Public key in test in Stripe. Key provided by stripe to safe use it in client
const stripe_pk = stripe_pk_from_env;
const stripePromise = loadStripe(stripe_pk);

function FilingCheckout({ clientSecret, filing, filingUuid }) {
  const [isDetailsConfirmed, setIsDetailsConfirmed] = useState(false);

  const appearance = {
    theme: "stripe",
    labels: "floating",
    inputs: "condensed",
  };

  const options = {
    clientSecret,
    appearance,
  };

  return (
    <Fragment>
      <div className="columns col2" style={{ margin: "0px" }}>
        <div style={{ margin: "0px" }}>
          <FilingResume
            filing={filing}
            isConfirmed={isDetailsConfirmed}
            onConfirmChange={setIsDetailsConfirmed}
          />
        </div>

        <div
          className="columns payment-form-container"
          style={{ margin: "0px", flex: "1 1 0", minWidth: 0 }}
        >
          {clientSecret && (
            <Elements options={options} stripe={stripePromise}>
              <CheckoutForm
                filingUuid={filingUuid}
                clientSecret={clientSecret}
                isDetailsConfirmed={isDetailsConfirmed}
              />
            </Elements>
          )}
        </div>
      </div>
    </Fragment>
  );
}

export default FilingCheckout;
